"use client";

import React from "react";
import Lightning from "./lightning";
import { useTheme } from "next-themes";
import { Skeleton } from "@/components/ui/skeleton";

export default function ThirdParallaxHome() {
  const [hasMounted, setHasMounted] = React.useState(false);
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  React.useEffect(() => {
    setHasMounted(true);
  }, []);

  return (
    <section className="w-full bg-[#FAFAFA] dark:bg-black min-w-[320px] flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
      <div className="relative z-20 w-full max-w-[1100px]">
        {/* Grid container with same height as hero section */}
        <div className="relative z-10 w-full h-full border-r-2 border-l-2 border-[#EAEAEA] dark:border-[#1E1E1E] pb-10 flex flex-col mx-auto">
          {/* Center left plus sign */}
          {/*           <div className="absolute z-[30] left-1/2 md:left-1/2 transform -translate-1/2 top-[46%] sm:top-[43.5%] md:top-[37.8%] flex items-center justify-center">
            <Plus className="text-[#A8A8A8] dark:text-[#878787] scale-100 md:scale-130" />
          </div> */}

          <div className="relative flex flex-col w-full h-full gap-3 items-start justify-center">
            {hasMounted ? (
              <>
                <div className="flex w-full h-1/5 items-center justify-center">
                  <h2 className="absolute top-25 md:top-23 lg:top-22 text-3xl md:text-5xl lg:text-6xl font-bold text-center z-40 px-4 py-2">
                    Charge Ahead
                  </h2>
                </div>
                <div className="flex flex-col w-full h-4/5">
                  <div className="flex w-full">
                    <div
                      className="w-1/4 h-7 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E] before:content-[''] before:absolute before:top-16.5 before:left-1/4 before:w-[50%] 
    before:h-[2px] before:bg-linear-to-r before:from-transparent 
    dark:before:via-white before:via-black before:to-transparent
"
                    ></div>
                    <div className="w-1/4 h-14 border-l-2 border-t-2 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E]"></div>
                    <div className="w-1/4 h-14 border-r-2 border-l-2 border-t-2 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E]"></div>
                    <div className="w-1/4 h-7 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E]"></div>
                  </div>
                  <div className="flex w-full h-30">
                    <Lightning
                      lightningColor={isDark ? [1, 1, 1] : [0, 0, 0]}
                      intensity={0.03}
                      size={0.7}
                      background={isDark ? [0, 0, 0] : [0.98, 0.98, 0.98]}
                    />
                  </div>

                  <div className="flex w-full">
                    <div
                      className="w-1/5 h-7 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E] before:content-[''] before:absolute before:bottom-13.5 before:left-1/5 before:w-[60%] 
    before:h-[2px] before:bg-linear-to-r before:from-transparent 
    dark:before:via-white before:via-black before:to-transparent"
                    ></div>
                    <div className="w-1/5 h-14 border-r-2 border-l-2 border-t-2 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E]"></div>
                    <div className="w-1/5 h-14 border-t-2 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E]"></div>
                    <div className="w-1/5 h-14 border-r-2 border-l-2 border-t-2 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E]"></div>
                    <div className="w-1/5 h-7 border-b-2 border-dashed border-[#EAEAEA] dark:border-[#1E1E1E]"></div>
                  </div>
                </div>
              </>
            ) : (
              <div className="w-full h-[250px] animate-pulse bg-neutral-200 dark:bg-neutral-800" />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
